import { useBoolean } from '../useBoolean';
import { useCounter } from '../useCounter';
import { useInterval } from '../useInterval';
function useCountdown(_a) {
    var seconds = _a.seconds, interval = _a.interval, isIncrement = _a.isIncrement;
    var _b = useCounter(seconds), count = _b.count, increment = _b.increment, decrement = _b.decrement, resetCounter = _b.reset;
    var _c = useBoolean(false), running = _c.value, start = _c.setTrue, stop = _c.setFalse;
    var reset = function () {
        stop();
        resetCounter();
    };
    useInterval(isIncrement ? increment : decrement, running ? interval : null);
    return [count, { start: start, stop: stop, reset: reset }];
}
export default useCountdown;
//# sourceMappingURL=useCountdown.js.map